import { MessageType } from './types'

export const highlightColorMap = new Map([
  ['default', 'var(--Red-Dark)'],
  ['error', 'var(--Red-Dark)'],
  ['documents', 'var(--Red-Dark)'],
  ['warning', 'var(--Warn)'],
  ['disabled', 'var(--Info)'],
  ['success', 'var(--Success)'],
  ['info', 'var(--White)']
])

export const backgroundColorMap = new Map([
  ['default', 'var(--White)'],
  ['error', 'var(--ErrorBG)'],
  ['warning', 'var(--WarnBG)'],
  ['disabled', 'var(--InfoBG)'],
  ['documents', 'var(--Transparent)'],
  ['success', 'var(--SuccessAltBG)'],
  ['info', 'var(--InfoDark)'],
  ['null', 'var(--White99)']
])

export const borderColorMap = new Map([
  ['default', 'var(--White)'],
  ['error', 'var(--Red-Dark)'],
  ['info', 'var(--White)'],
  ['warning', 'var(--Warn)'],
  ['disabled', 'var(--Info)'],
  ['documents', 'var(--White90)'],
  ['success', 'var(--Success)'],
  ['null', 'var(--White90)']
])

export const getToastBackgrounColor = (messageType: MessageType) => {
  let backgroundColor = 'var(--White)'
  if (messageType === 'warning') {
    backgroundColor = 'var(--Orange-Light)'
  } else if (messageType === 'success') {
    backgroundColor = 'var(--Success)'
  }
  return backgroundColor
}

export const getToastBorderColor = (messageType: MessageType) => {
  let backgroundColor = 'var(--White)'
  if (messageType === 'warning') {
    backgroundColor = 'var(--Orange-Dark)'
  } else if (messageType === 'success') {
    backgroundColor = 'var(--Success)'
  }
  return backgroundColor
}
